export { default } from './AntUploadFile';
